import * as types from './types';

export const fetchApprovalNotificationsRequest = (payload) => ({
  type: types.FETCH_APPROVAL_NOTIFICATIONS_REQUEST,
  payload
});

export const fetchApprovalNotificationsSuccess = (payload) => ({
  type: types.FETCH_APPROVAL_NOTIFICATIONS_SUCCESS,
  payload
});

export const fetchApprovalNotificationsFailure = (error) => ({
  type: types.FETCH_APPROVAL_NOTIFICATIONS_FAILURE,
  payload: error
});


export const setApprovalNotificationCount = (count) => ({
  type: types.SET_APPROVAL_NOTIFICATION_COUNT,
  payload: count
});

export const openApprovalNotificationModal = () => ({
  type: types.OPEN_APPROVAL_NOTIFICATION_MODAL
});

export const closeApprovalNotificationModal = () => ({
  type: types.CLOSE_APPROVAL_NOTIFICATION_MODAL
});
